import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as url from "api/url";
import { Grid, Typography, LinearProgress, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getAllResources } from "action/cultureAction";
import EventMarkerTable from "./eventMarkerTable";
import CreateEventMarker from "./CreateEventMarker";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { getAllBuildingsList } from "action/ReportManagement/ManageReports";
import APIutil from "api/APIutils";

export const EventMarker = (params) => {
  const [EventMarkerList, setEventMarkerList] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [deleteEventMarkerId, setDeleteEventMarkerId] = useState(0);
  const [buildingVals, setbuildingVals] = useState([]);

  const dispatch = useDispatch();
  const labels = useSelector(
    (state) =>
      state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference
  );

  const buildingsSelector = useSelector(
    (state) => state.DataExportBuildingReducer.Buildings
  );

  // delete dialog strings amd functions
  const [open, setOpen] = React.useState(false);
  const [openForMore, setOpenForMore] = React.useState(false);
  const [confirmationText, setConfirmationText] = React.useState(
    labels["EventMarker.Delete.Confirmation.Text"]
  );
  const yesText = labels["ReportManagement.Yes.Text"];
  const noText = labels["ReportManagement.No.Text"];
  const confirmationBaseText = labels["EventMarker.Delete.Confirmation.Text"];
  const confirmationTypeText =
    labels["EventMarkerType.Delete.Confirmation.Text"];
  const confirmationTitle = labels["AreYouSure.Text"];
  const [docList, setDocList] = React.useState(<div></div>);
  const [eventMarkerHeader, setEventMarkerHeader] = React.useState("");
  const attachmentText = labels["Attachments.Text"];
  const [rows, setRows] = React.useState([]);
  const [filtered_data, setFiltered_data] = React.useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    setOpen(false);
    deleteSelectedEventMarker();
  };

  const deleteEventMarker = (eventMarkerId) => {
    if (eventMarkerId > 0) {
      // if the event marker type will be deleted as well, add that to the confirmation text
      let fdn = EventMarkerList.find(
        (em) => em.eventMarkerId === eventMarkerId
      );
      let confirmTxt = confirmationBaseText.replace(
        "{0}",
        fdn.eventMarkerDisplayDate
      );

      if (fdn) {
        let fdnType = EventMarkerList.filter(
          (em) => em.eventMarkerTypeId === fdn.eventMarkerTypeId
        );
        if (
          fdnType.length === 1 &&
          fdnType[0].eventMarkerId === eventMarkerId
        ) {
          setConfirmationText(
            confirmTxt +
              " " +
              confirmationTypeText.replace(
                "{0}",
                fdnType[0].eventMarkerTypeTitle
              )
          );
        } else {
          setConfirmationText(confirmTxt);
        }
      }

      setDeleteEventMarkerId(eventMarkerId);
      handleClickOpen();
    }
    setShowCreate(false);
  };

  const handleClickOpenForMore = () => {
    setOpenForMore(true);
  };

  const handleCloseForMore = () => {
    setOpenForMore(false);
  };

  const showMore = (docsToDisplay) => {
    if (docsToDisplay && docsToDisplay.length > 0) {
      createDocList(docsToDisplay);
      handleClickOpenForMore();
    }
    setShowCreate(false);
  };

  function createDocList(itemList) {
    let attch = itemList.split(";").map((d, idx) => {
      return (
        <div
          key={idx}
          onClick={() => {
            downloadAttachment(d);
          }}
          className="linkCursor"
          style={{ lineHeight: "20px" }}
        >
          {d}
        </div>
      );
    });
    setDocList(attch);
  }

  async function downloadAttachment(fileName) {
    if (fileName !== null && fileName !== "") {
      await APIutil.getPDFDataAPI(url.get_Attachment + fileName.trim())
        .then((response) => {
          if (!response.status || response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
          } else if (response.status === 404) {
            // set file does not exist message somewhere
          }
        })
        .catch((error) => {
          throw error;
        });
    }
  }

  useEffect(() => {
    if (buildingsSelector.length > 0) {
      let buildVal = [];

      const buildingId = sessionStorage.getItem("buildingId") || "0";
      if (buildingId !== "0") {
        const building = buildingsSelector.find(
          (bl) => buildingId === bl.siteID.toString()
        );
        setEventMarkerHeader(`Event Markers for ${building.siteName}`);
      }
      // eslint-disable-next-line array-callback-return
      buildingsSelector.map((bl) => {
        buildVal.push(bl.siteName);
      });

      let sortedValue = buildVal.sort((a, b) => {
        let fa = a.toLowerCase(),
          fb = b.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });

      setbuildingVals(sortedValue);
    }
  }, [buildingsSelector]);

  async function deleteSelectedEventMarker() {
    if (!isNaN(deleteEventMarkerId) && parseInt(deleteEventMarkerId) > 0) {
      await APIutil.deleteDataAPI(url.delete_EventMarker + deleteEventMarkerId)
        .then(() => {
          setDeleteEventMarkerId(0);
          getEventMarkerList();
        })
        .catch((error) => {
          throw error;
        });
    }
  }

  // end delete dialog strings and functions

  const editEventMarker = (eventMarker) => {
    if (eventMarker.eventMarkerId > 0) {
      setSelectedEventMarker(eventMarker);
    }
    setShowCreate(eventMarker.eventMarkerId > 0);
  };

  async function getEventMarkerList(buildingId) {
    const requestBody = url.get_Eventmarker_List + `/${buildingId}`;
    await APIutil.getDataAPI(requestBody)
      .then((res) => {
        setEventMarkerList(res);
        setRows(res);
        setisLoading(false);
      })
      .catch((error) => {
        throw error;
      });
  }

  useEffect(() => {
    dispatch(getAllResources());
    setisLoading(true);
  }, []);

  useEffect(() => {
    const buildingId = sessionStorage.getItem("buildingId") || "0";
    setEventMarkerHeader(labels["EventMarkers.HeaderTitle.Text"]);
    getEventMarkerList(buildingId);
    dispatch(getAllBuildingsList());
  }, [labels]);

  const [selectedEventMarker, setSelectedEventMarker] = useState({
    eventMarkerId: 0,
  });

  useEffect(() => {
    if (rows.length > 0) {
      setFiltered_data(rows);
    }
  }, [rows]);

  const setDisplay = (showList) => {
    // reset selected event marker to empty since this is a create request
    setSelectedEventMarker({ eventMarkerId: 0 });
    setShowCreate(showList);

    if (!showList) {
      setisLoading(true);
      getEventMarkerList();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#f5f6fa",
        width: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "1220px",
          width: "97%",
          minWidth: "650px",
        }}
      >
        {showCreate ? (
          <CreateEventMarker
            buildingOptions={buildingVals}
            backToList={setDisplay}
            selectedEventMarker={selectedEventMarker}
            eventMarkerData={filtered_data}

          />
        ) : (
          <Grid id="tableGrid" container spacing={2}>
            <Grid item xs={12} pt={6}>
              {isLoading && <LinearProgress />}
              <EventMarkerTable
                rows={filtered_data}
                labels={labels}
                editItem={editEventMarker}
                deleteItem={deleteEventMarker}
                showMore={showMore}
                downloadAttachment={downloadAttachment}
                eventMarkerHeader={eventMarkerHeader}
                createEventMarker={()=>{setDisplay(true)}}
              />
            </Grid>

            <Grid id="deleteDialog" item xs={12}>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
              >
                <DialogTitle id="alert-dialog-title" sx={{ fontSize: "16px" }}>
                  {confirmationTitle}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-description"
                    sx={{ fontSize: "14px", lineHeight: "1.25 !important" }}
                  >
                    {confirmationText}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    id="ev_cancel_button"
                    className="eventMarkerButton eventMarkerCancelButton"
                    variant="outlined"
                    onClick={handleClose}
                  >
                    {noText}
                  </Button>
                  <Button
                    id="ev_save_button"
                    className="eventMarkerButton"
                    variant="contained"
                    onClick={handleDelete}
                    autoFocus
                  >
                    {yesText}
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>

            <Grid id="showMoreDialog" item xs={12}>
              <Dialog
                open={openForMore}
                onClose={handleCloseForMore}
                aria-labelledby="alert-dialog-title-showMore"
                aria-describedby="alert-dialog-description-showMore"
              >
                <DialogTitle id="alert-dialog-title-showMore">
                  <Typography variant="h5">
                    <div>{attachmentText}</div>
                  </Typography>
                  <IconButton
                    aria-label="close"
                    onClick={handleCloseForMore}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description-showMore">
                    <div>{docList}</div>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default EventMarker;
